




















import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "SuggestedCreatorsItem",
  components: {
    BaseAvatar,
    BaseButton,
  },
  props: {
    creator: { type: Object as () => UserPublicData, required: true },
    isFollowing: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const backgroundStyle = computed(() => {
      if (!props.creator.background) {
        return "";
      }
      const background = MediaFilesController.getImageThumbnail(props.creator.background.urlPart, "480p");
      return {
        "--backgroundImage": `url('${background}')`,
      };
    });
    const profileUrl = computed(() => getProfileUrl(props.creator));
    const goToProfile = () => root.$router.push(profileUrl.value);

    return {
      goToProfile,
      backgroundStyle,
    };
  },
});
